export default "__VITE_ASSET__fBd__66P__"